import styled from "styled-components/macro";
import {useFeedback} from "../../../store/feedback";
import {useBaseCommunity, useUsername} from "../../../store/hooks";
import {useCommunityStyle} from "../../../api/communities";
import {useFullModeratorsList} from "../../../api/moderation";
import HeaderData from "../../../components/header_data";
import Header from "../../../components/header";
import TopBar from "../../../components/top_bar";
import CommunityHeader from "../../../components/community_header";
import {isPseudoCommunity} from "../../../store/communites";
import SortBar from "../../../components/sort_bar";
import Container from "../../../components/container";
import Wrapper from "../../../components/wrapper";
import {useParams} from "react-router-dom";
import Main from "../../../components/main";
import Sidebar from "../../../components/sidebar";
import Footer from "../../../components/footer";
import NavLink from "../../../components/nav_link";
import {useModal, useRelativeTime} from "../../../store";
import ModeratorDetails from "../../../components/modals/moderation/moderator_details";
import NewModerator from "../../../components/modals/moderation/new_moderator";
import {useState} from "react";
import {Button} from "@chakra-ui/react";
import CommunityInfo from "../../../components/community_info";
import LegacySortBar from "../../../components/legacy/legacy_sort_bar";
import useWindowDimensions from "../../../utils/dimensions";
import {themecolors} from "../../../utils/themecolors";
import {ExternalLink} from "lucide-react";

const Sort = styled.div``;
const SortOptions = styled.div``;
const Expand = styled.span``;
const Info = styled.div``;
const Add = styled.div``;

const Moderator = styled(({className, moderator, community, canEdit, setTime}) => {
    const ago = useRelativeTime(moderator.created, true);
    const modal = useModal();
    const handleExpand = () => {
        modal.open(ModeratorDetails, {moderator, community, setTime});
    };
    const permissionText = moderator.permissions.all_permissions ? 'All Permissions' : 'Mixed Permissions';
    return (
        <tr className={className}>
            <td><NavLink href={`/u/${moderator.author}`} react_route>{moderator.author}</NavLink></td>
            <td>{ago} ago</td>
            <td style={{display: 'flex', alignItems: 'center'}}>
                {permissionText}
                {canEdit && moderator.can_edit &&
                    <Expand onClick={handleExpand}>
                        <ExternalLink size={14} />
                    </Expand>
                }
            </td>
        </tr>
    )
})`
`;

const Moderators = styled(({className}) => {

    const username = useUsername();
    const {error, feedbackCh} = useFeedback();
    const baseCommunity = useBaseCommunity();
    const {community: paramsCommunity} = useParams();
    const community = paramsCommunity || baseCommunity;
    const style = useCommunityStyle(community);

    const [time, setTime] = useState(Date.now());
    const fullModerators = useFullModeratorsList(feedbackCh, community, time);
    const moderators = fullModerators?.moderators;
    const canEdit = fullModerators?.can_edit;

    const modal = useModal();
    const handleAdd = () => {
        modal.open(NewModerator, {community, setTime});
    }

    const {width} = useWindowDimensions();

    return (
        <>
            <HeaderData title={`Community Moderators`} community={community} community_style={style}/>
            <Header>
                {(baseCommunity !== "TheDonald" || width <= 780) && <TopBar legacyConversion={baseCommunity === "TheDonald"} />}
                {!isPseudoCommunity(community) &&
                    <>
                        <CommunityHeader community={community}/>
                        {baseCommunity !== "TheDonald" &&
                            <CommunityInfo desktop community={community}/>
                        }
                    </>
                }
                {baseCommunity === "TheDonald" && width > 780 && <LegacySortBar />}
            </Header>
            <SortBar community={community} />
            <Container className={className} forceWidth={"slim"}>
                <Wrapper>
                    <Main>
                        <table>
                            <tr>
                                <th>Username</th>
                                <th>Time</th>
                                <th>Permissions</th>
                            </tr>
                            {moderators && moderators.map((moderator, i) => (
                                <Moderator key={i} moderator={moderator} community={community} canEdit={canEdit} setTime={setTime} />
                            ))}
                        </table>
                        {canEdit &&
                            <Button mt={"12px"} variant={"grey"} onClick={() => handleAdd()}>Add Moderator</Button>
                        }
                    </Main>
                </Wrapper>
                <Sidebar sidebar={style?.sidebar} community={community} />
            </Container>
            <Footer />
        </>
    );
})`
  ${Main} {
    padding: 20px;
    font-size: 14px;
  }
  table {
    border-collapse: collapse;
    width: 100%;
  }
  th {
    text-align: left;
    font-weight: 500;
    font-size: 16px;
  }
  ${Info} {
    display: flex;
    align-items: center;
    white-space: break-spaces;
  }
  ${Expand} {
    padding-left: 4px;
    cursor: pointer;
  }
  ${Sort} {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
    cursor: pointer;
    white-space: nowrap;
    margin-left: 32px;
  }
  ${Sort} svg {
    margin-left: 12px;
  }
  ${SortOptions} {
    margin-left: auto;
    display: flex;
  }
  ${Add} {
    cursor: pointer;
  }
  @media only screen and (max-width: 780px) {
  }
`;

export default Moderators;
